import { Grid } from "@mui/material";
import React from "react";
import Input from "../../../../components/input/Input-v2";

interface RetailInput {
  control: any;
  isFetching: boolean;
  disable?: boolean;
}

export default function RetailInput({
  control,
  isFetching,
  disable,
}: RetailInput) {
  return (
    <React.Fragment>
      <Grid item xs={12} md={12}>
        <Input.Controller
          control={control}
          name="customer_name"
          rules={{ required: "Kolom ini tidak boleh kosong" }}
          render={(field, fieldState) => (
            <Input.Text
              showAsStatic={disable}
              disable={disable}
              isFetching={isFetching}
              label="Nama Customer"
              value={field.value}
              onChange={(e) => field.onChange(e)}
              error={fieldState.error?.message}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input.Controller
          control={control}
          name="customer_address"
          render={(field) => (
            <Input.Text
              showAsStatic={disable}
              disable={disable}
              isFetching={isFetching}
              label="Alamat Customer"
              value={field.value}
              onChange={(e) => field.onChange(e)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input.Controller
          control={control}
          name="customer_phone_number"
          render={(field) => (
            <Input.Text
              showAsStatic={disable}
              disable={disable}
              isFetching={isFetching}
              label="Telp Customer"
              value={field.value}
              onChange={(e) => field.onChange(e)}
            />
          )}
        />
      </Grid>
    </React.Fragment>
  );
}
